var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn-hotline c-btn-hotline",on:{"click":_vm.handleCall}},[_c('span',{staticStyle:{"font-size":"12px !important"}},[_vm._v("Hotline:")]),_c('span',{staticStyle:{"color":"#ffff !important"}},[_vm._v(" 02471001088")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }